import { render, staticRenderFns } from "./Votegroup.vue?vue&type=template&id=6e59a158&scoped=true"
import script from "./Votegroup.vue?vue&type=script&lang=js"
export * from "./Votegroup.vue?vue&type=script&lang=js"
import style0 from "./Votegroup.vue?vue&type=style&index=0&id=6e59a158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e59a158",
  null
  
)

export default component.exports